
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"시작하기"}}>{`시작하기`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"채용-사이트-컴포넌트-요구사항"}}>{`채용 사이트 컴포넌트 요구사항`}</MDXTag>
<MDXTag name="p" components={components}>{`모든 채용 사이트 컴포넌트들은 다음과 같은 전역 css 설정에 의존하고 있습니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-scss"}}>{`@import url('https://fonts.googleapis.com/earlyaccess/notosanskr.css');
:root {
  font-size: 1px;
}
body {
  font-size: 16rem;
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 400; // regular: 400, medium: 500, bold: 600
  letter-spacing: -0.1rem;
  color: \$gray-0;
  -webkit-font-smoothing: antialiased;
}
* {
  font-family: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  color: inherit;
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  